<style scoped>
	.c-panel{margin: 0px; padding: 0px 20px;}
</style>

<template>
	<el-dialog
		v-if="m"
		title="课程修改"
		:visible.sync="isShow"
		width="400px"
		top="25vh"
		:append-to-body="true"
		:destroy-on-close="true"
		:close-on-click-modal="false"
		custom-class="full-dialog"
		>
		<div class="vue-box">
			<div class="c-panel">
				<!-- 参数栏 -->
				<br>
				<el-form size="mini">
					<el-form-item label="编号：">
						<el-input v-model="m.id" disabled></el-input>
					</el-form-item>
					<el-form-item label="上课时间：" v-show="m.status==0">
            <el-date-picker
                v-model="m.time"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择上课日期时间">
            </el-date-picker>
					</el-form-item>
          <el-form-item label="带班老师：" v-show="m.status==0">
            <el-select size="mini" v-model="m.teaId">
              <el-option v-for="tea in teacherList" :label="tea.name" :value="tea.id" :key="tea.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="课程评价：" v-show="m.status!=0">
            <el-input v-model="m.des"></el-input>
          </el-form-item>
				</el-form>
			</div>
		</div>
		<span slot="footer" class="dialog-footer">
			<el-button size="small" @click="isShow = false">取 消</el-button>
			<el-button size="small" type="primary" @click="ok()">确 定</el-button>
		</span>
	</el-dialog>
</template>

<script>
	export default {
		data() {
			return {
				isShow: true,
				id: 0,
				m: null,
        teacherList:[],

			}
		},
		methods: {
      getTeacherList:function (){
        this.sa.ajax('api/psdAdmin/teacher/getList',
            {},
            function(res){
              this.teacherList = res.data;
              console.log('老师',res.data);
            }.bind(this),{async:false});
      },
			// 打开
			open: function(id) {
          this.isShow = true;
          //id 非 0 代表 是要修改 先查询一下，把旧值显示在input中
          this.sa.ajax('api/psdAdmin/clazzCard/getClazzCardInfoById', {id: id}, function(res) {
            this.m = res.data;
            console.log(res.data);
          }.bind(this), /*{res: this.getMockData(id)}*/);
			},
			// 表单验证
			submit_check: function() {
				var m = this.m;
				var sa = this.sa;
				if(sa.isNull(m.time)) {
					return sa.error('请输入上课时间');
				}
        if(sa.isNull(m.teaId)) {
          return sa.error('请选择带班老师');
        }
				return 'ok';
			},
			// 提交
			ok: function() {
				// 表单验证
				if(this.submit_check() != 'ok') {
					return;
				}
				// 开始增加或修改
				let self = this;
        // id != 0 为修改
        this.sa.ajax('api/psdAdmin/clazzCard/updateClazzCardInfo', JSON.stringify(this.m), function(res){
          if(res.code == '0') {
            self.sa.alert('修改成功', function () {
              self.$parent.f5();	// 父视图刷新
              self.isShow = false;
            });
          }else{
            this.sa.error(res.msg || '修改失败');
          }
        },{ contentType:"application/json;charset=UTF-8"});
      },
		},
		created: function(){
			this.getTeacherList();
		}
	}
</script>
